/**
 * Function to submit feedback
 * @param {string} feedbackText The feedback provided by customer
 * @param {int} rating The rating stars count provided by customer
 * @param {"Preview" | "PopUp"} from The section that user send feedback
 * @param {string} source The url user preview
 */
function submitFeedback(feedbackText, rating, from, source) {
    let report = "PLATFORM: Chrome-" + from + "\n";
    report += "RATING: " + rating + "\n";
    report += "LOCATION: " + source + "\n\n";

    chrome.runtime.sendMessage({
        action: "submit-feedback",
        data: {
            feedbackText: feedbackText,
            report: report
        }
    });
}

export {submitFeedback};
